
import { Model } from 'backbone';

class LineModel extends Model {

    initialize() {
    }

    defaults() {
        const def = {};
        def.factoryKey = 'connection_arrow';
        def.textBoxWidth = '100';
        def.lineType = 'straight';
        def.ValueOfAField = '';
        def.ConditionalValue = '';
        def.text = '';
        def.autosummary = '';
        def.fieldName = '';
        def.ctrlPoint1x = '';
        def.ctrlPoint2x = '';
        def.ctrlPoint1y = '';
        def.ctrlPoint2y = '';
        
        return def;
    }
}

export default LineModel;
